module.exports = __webpack_public_path__ + "static/media/folder-rectangle-check.46b1695c.svg";